import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import { NotifyService } from "../services/notify-service";
import { InfoService } from "../services/info-service";
import { LocalCacheService } from "../services/local-cache-service";
import { AlertService } from "../services/alert-service";
import { AdminConfigService } from "../services/admin-config-service";
import * as angular from "angular";
import * as moment from "moment";
import * as Favico from "favico.js/favico";

export function RLUserNotificationsMenuBar() {
    var directive: ng.IDirective = {
        restrict: "A",
        require: "rlUserNotificationsMenuBar",
        controllerAs: "notificationsVM",
        controller: RLUserNotificationsController,
        template: require("/assets/app/templates/user-notifications-menu-bar.html")
    };
    return directive;
}

export function RLUserNotificationsList() {
    var directive: ng.IDirective = {
        restrict: "E,A",
        require: "rlUserNotificationsList",
        controllerAs: "notificationsVM",
        controller: RLUserNotificationsController,
        template: require("/assets/app/templates/user-notifications-list.html")
    };
    return directive;
}

class RLUserNotificationsController {

    static $inject = ["$scope", "$q", "$window", "infoService", "notifyService", "localCacheService", "alertService", "adminConfigService", "charTypeIcons"];

    notifications: Models.UserNotification[];
    loading: boolean;

    unreadStatus: string;
    readStatus: string;
    deleteStatus: string;
    getNotificationsCacheKey: string;
    selectedItems: _.Dictionary<boolean>;
    allChecked: boolean;
    charTypes: Models.IKeyValuePair<string, string>[];
    selectedCharTypeIDs: string;
    selectedStatuses: string;
    count: number;
    page: number;
    pageCount: number;
    numFound: number;
    sortDir: string;
    sortField: string;

    favicon = new Favico(
        {
            animation: "fade",
            bgColor: "#a94442",
            fontFamily: "Helvetica",
            fontStyle: "bold"
        });

    constructor(
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private $window: ng.IWindowService,
        private infoService: InfoService,
        private notifyService: NotifyService,
        private localCacheService: LocalCacheService,
        private alertService: AlertService,
        private adminConfigService: AdminConfigService,
        private charTypeIcons: any) {
        this.loading = true;
        this.allChecked = false;
        this.count = 10;
        this.page = 1;
        this.pageCount = 0;
        this.numFound = 0;
        this.unreadStatus = 'S';
        this.readStatus = 'R';
        this.deleteStatus = 'D';
        this.charTypes = [];
        this.selectedCharTypeIDs = '-1';
        this.selectedStatuses = 'S';
        this.sortDir = "1";
        this.sortField = "CRE_TMS"
        this.getNotificationsCacheKey = `getUserNotifications_${this.count}_${this.unreadStatus}`;
        this.selectedItems = {};
    }

    Init() {
        var ctPromise = this.adminConfigService.GetEntityCharTypes()
            .then((result) => {
                this.charTypes = result;
                this.GetNotifications();
            });
    }

    GetNotifications() {
        this.notifyService.startProgress();
        var sortDirection = this.sortDir == '1' ? 'DESC' : 'ASC';

        this.infoService.getUserNotificationsCount(this.selectedStatuses, this.selectedCharTypeIDs, this.sortField, sortDirection)
            .then((countResult) => {
                this.numFound = countResult.data;
                this.pageCount = this.count != 0 ? Math.ceil(countResult.data / this.count) : 0;
                this.infoService.getUserNotifications(this.page, this.count, this.selectedStatuses, this.selectedCharTypeIDs, this.sortField, sortDirection).then((result) => {
                    this.favicon.badge(result.length);
                    this.notifications = result;
                    this.loading = false;
                });
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    isToday(createdAt: string) {
        if (moment(createdAt, "YYYY-MM-DDTHH:mm:ss.Z").isValid()) {
			return moment(createdAt, "YYYY-MM-DDTHH:mm:ss.Z").isAfter(moment().startOf('day'));
        }
        return false;
    }

    GetCharTypeIcon(item: Models.UserNotification) {
        for (var i = 0; i < this.charTypeIcons.length; i++) {
            var ct = this.charTypeIcons[i];
            if (ct.charTypeID == Utils.IdBuilder.splitEntityID(item.entityID).charTypeID) {
                return ct.class;
            }
        }
        return '';
    }

    AllCheckChanged() {
        _.forEach(this.notifications, (itemRow) => {
            this.selectedItems[itemRow.id] = this.allChecked;
        });
    }


    FilterUpdated() {
        this.page = 1;
        this.GetNotifications();
    }

    MarkSelectedNotificationsRead() {
        this.UpdateSelected(this.readStatus);
    }

    MarkSelectedNotificationsUnread() {
        this.UpdateSelected(this.unreadStatus);
    }
    MarkSelectedNotificationsDeleted() {
        this.UpdateSelected(this.deleteStatus);
    }

    DeleteNotification(notification: Models.UserNotification) {
        this.UpdateNotification(notification, this.deleteStatus);
    }

    UpdateNotification(notification: Models.UserNotification, status: string) {
        this.loading = true;

        this.infoService.setNotificationStatus([notification.id], status).then((result) => {
            this.notifyService.notifySuccess(result.data + ' notifications updated.');
            this.selectedItems = {};
            this.allChecked = false;
            this.GetNotifications();
        }).finally(() => {
            this.loading = false;
        });
    }

    AnySelected() {
        return _.any(this.selectedItems, (i) => i);
    }

    UpdateSelected(status: string) {
        var promises = [];
        this.notifyService.startProgress();
        this.loading = true;
        var picked = _.keys(_.pick(this.selectedItems, (i) => i)).map(Number);
        this.infoService.setNotificationStatus(picked, status)
            .then(() => {
                this.notifyService.notifySuccess('Notification status updated.');
                this.selectedItems = {};
                this.allChecked = false;
                this.GetNotifications();
            }).finally(() => {
                this.loading = false;
                this.notifyService.endProgress();
            });
    }

    MarkAllAsRead() {
        if (this.$window.confirm("Are you sure you want to mark ALL Unread notifications as Read?")) {
            this.notifyService.startProgress();
            this.loading = true;
            this.infoService.setAllNotificationsToReadStatus(this.selectedCharTypeIDs).then((result) => {
                this.notifyService.notifySuccess(result.data + ' notificaitons updated.');
                this.selectedItems = {};
                this.allChecked = false;
                this.GetNotifications();
            }).finally(() => {
                this.loading = false;
                this.notifyService.endProgress();
            });
        }
    }

    MarkAsRead(notification: Models.UserNotification) {
        this.UpdateNotification(notification, this.readStatus);
    }

    PageChanged(page) {
        this.GetNotifications();
    }

    PageSizeChanged(pageSize) {
        this.page = 1;
        this.GetNotifications();
    }

    SortChanged(sortField, sortDir) {
        this.GetNotifications();
    }

    ReadThenRedirect(item: Models.UserNotification) {
        this.infoService.setNotificationStatus([item.id], this.readStatus).then(() => {
            this.GetNotifications(); // reset the list 
            //Is the Notification tied to a component chartype?  If so, we need to link to its parent, not itself.
            var entityCharType = Utils.IdBuilder.splitEntityID(item.entityID).charTypeID;
            if (!Utils.CharUtil.IsModuleLevelCharType(entityCharType)) {
                this.alertService.getParentRecordEntityID(item.entityID)
                    .then((result) => {
                        if (result.data != null) {
                            this.$window.open("/Go/" + result.data, "_blank");
                        }
                        else {
                            this.$window.open("/Go/" + item.entityID, "_blank");
                        }
                    });
            }
            else {
                this.$window.open("/Go/" + item.entityID, "_blank");
            }
        });
    }

}
